<template>
    <div>
      <van-nav-bar
      title="资料修改"
      left-text="返回"
      left-arrow
      @click-left="historyBack"
    />
    
    <el-form label-position="left" label-width="80px" style="margin: 10px;" class="myform" size="mini">
        <el-form-item label="头像">
          <el-row>
            <el-col :span="12">
              <el-upload class="avatar-uploader" :action="uploadFile" :show-file-list="false" accept="image/*"
                :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-col>
            <el-col :span="12">
              <el-upload class="avatar-uploader" :action="uploadFile" :show-file-list="false" v-if="workAvatar.staffid" disabled
                :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                <img v-if="workAvatar.work1" :src="baseImageUrl+workAvatar.work1" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip"><span type="danger" style="color:#f56c6c">待审核</span></div>
              </el-upload>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="艺名">
          <el-input v-model="staff.staffnickname"></el-input>
        </el-form-item>
        <el-form-item label="休息日">
          <el-select v-model="staff.restday" placeholder="请选择休息日" style="width: 100%;">
            <el-option label=" " :value="0"></el-option>
            <el-option label="周一" :value="1"></el-option>
            <el-option label="周二" :value="2"></el-option>
            <el-option label="周三" :value="3"></el-option>
            <el-option label="周四" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="个人介绍">
          <el-input type="textarea" :autosize="{ minRows: 4}" v-model="staff.introduce"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="updateStaff">保存</el-button>
          <el-button @click="openStaffRest">新增请假</el-button>
          <el-button @click="openStaffRestData">请假记录</el-button>
        </el-form-item>
      </el-form>
      <el-dialog title="新增请假信息" :visible.sync="dialogVisible" width="100%">
        <el-form label-position="left" label-width="80px" style="margin: 10px;" class="myform">
          <el-form-item label="请假类型">
            <el-select v-model="addStaffRest.leavetype" placeholder="请选择请假类型" style="width: 100%;">
              <el-option :label="item.constantname" :value="item.constantid" v-for="(item,index) in leaves" :key="index">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始日期">
            <el-date-picker style="width: 100%" v-model="addStaffRest.fromdate" type="date" placeholder="开始日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期">
            <el-date-picker style="width: 100%" v-model="addStaffRest.todate" type="date" placeholder="结束日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveStaffRest">确 定</el-button>
        </span>
      </el-dialog>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                dialogVisible:false,
                uploadFile: process.env.API_ROOT+"file/fileUpload?token=" + localStorage.getItem("token"),
                imageUrl:"",
                staff:{},
                staffid:"",
                workAvatar:{},
                staffRest: {
                  storeid: "",
                  sysbillid: "",
                  staffid: "",
                  leavetype: "",
                  fromdate: "",
                  todate: "",
                  status: 99,
              },
              addStaffRest: {},
            }
        },
        created:function(){
            this.staffid=this.$route.query.staffid;
            this.getStaffById();
            this.getStaffWorksByAvatar();
            this.getLeaveInfo();
        },
        methods: {
            openStaffRestData(){
              this.$router.push({path:"/staffrest",query:{
                    staffid:this.staffid,
                }});
            },
            getLeaveInfo() {
              this.$post("newcardapp/getLeaveInfo").then(res => {
                if (res.sucess) {
                  this.leaves = res.object;
                } else {
                  this.$message.error(res.message);
                }
              });
            },
            openStaffRest() {
              this.addStaffRest = this.$copy(this.staffRest);
              this.dialogVisible = true;
            },
            saveStaffRest() {
                if (!this.addStaffRest.leavetype) {
                  this.$message.error("请选择请假类型");
                  return;
                }
                if (!this.addStaffRest.fromdate) {
                  this.$message.error("请选择开始日期");
                  return;
                }
                if (!this.addStaffRest.todate) {
                  this.$message.error("请选择结束日期");
                  return;
                }
                this.addStaffRest.storeid = this.staff.storeid;
                this.addStaffRest.staffid = this.staff.staffid;
                this.$postw("newcardapp/saveStaffRest", this.addStaffRest).then(res => {
                  if (res.sucess) {
                    this.$message({
                      message: '保存成功',
                      type: 'success'
                    });
                    this.dialogVisible = false;
                  } else {
                    this.$message.error(res.message);
                  }
                });
            },
            updateStaff() {
              this.$postw("newcardapp/updateStaff", this.staff).then(res => {
                if (res.sucess) {
                  this.$message({
                    message: '保存成功',
                    type: 'success'
                  });
                } else {
                  this.$message.error(res.message);
                }
              });
            },
            getStaffWorksByAvatar(){
              this.$post("hairwork/getStaffWorksByAvatar",{staffid:this.staffid}).then(res=>{
                if(res.sucess){
                    this.workAvatar=res.object;
                    if(!this.workAvatar){
                      this.workAvatar={};
                    }
                }
                else{
                  this.$message.error(res.message);
                }
              });
            },
            saveStaffAvatar(icon){
              let obj=new Object();
              obj.storeid=this.staff.storeid;
              obj.staffid=this.staff.staffid;
              obj.workname=this.staff.staffname+"头像";
              obj.work1=icon;
              obj.work2="";
              obj.work3="";
              obj.billtype=2;
              obj.status=1;
              this.$postw("hairwork/saveHairWork",obj).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message: '头像上传成功等待审核',
                            type: 'success',
                        });
                        this.getStaffWorksByAvatar();
                    }
                    else{
                        this.loading=false;
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            },
            getStaffById(){
                this.$post("staff/getStaffById",{staffid:this.staffid}).then(res=>{
                    if(res.sucess){
                        this.staff=res.object;
                        if(res.object.icon){
                          this.imageUrl=this.baseImageUrl+res.object.icon;
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
                const isLt2M = file.size / 1024 / 1024 < 4;
                if (!isJPG) {
                    this.$message.error('上传头像图片只能是 JPG 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 4MB!');
                }
                return isJPG && isLt2M;
            },
            handleAvatarSuccess(res, file) {
                //this.staff.icon = res.object;
                //this.imageUrl=this.baseImageUrl+res.object;
                this.saveStaffAvatar(res.object);
                
                //this.updateStaffIcon(this.staff.icon);
            }
            
        }
    }
</script>
<style style lang="scss" rel="stylesheet/scss">
  .avatar {
    width: 118px;
    height: 118px;
    display: block;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 118px;
    height: 118px;
    line-height: 118px;
    text-align: center;
  }
</style>


// WEBPACK FOOTER //
// src/page/hair/hairbasic.vue